<template>
  <v-container>
    <v-app-bar light color="white" flat class="header">
      <v-btn
        v-if="this.$route.path !== '/'"
        class="header-back"
        depressed
        text
        x-small
        @click="goBack"
      >
        <v-icon>mdi-keyboard-backspace</v-icon>
      </v-btn>
      <v-toolbar-title class="header__logo pl-0">
        <router-link to="/">VGP JSC <span>Giftcode</span></router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <router-link
        class="header-logout__text"
        v-if="!isAuthenticated"
        to="/login"
      >
        Đăng nhập
      </router-link>
      <div class="header-login" v-if="isAuthenticated">
        {{ username }}
      </div>
      <v-menu offset-y class="header-logout__menu">
        <template class="header-logout__menu" v-slot:activator="{ on, attrs }">
          <v-btn
            class="header-logout__btn"
            fab
            depressed
            dark
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="support()"
          >
            <img src="../assets/icons/user.svg" alt="" />
          </v-btn>
        </template>

        <v-list
          outlined
          class="header-logout__dropdown"
          :class="{ activeSupport: activeClass }"
        >
          <v-list-item
            v-if="isAuthenticated"
            class="header-logout__menu logout"
            outlined
          >
            <v-list-item-title outlined class="header-logout__menu--title">
              <router-link to="/login">
                <div @click=";(overlay = false), logout()">
                  Đăng xuất
                  <img
                    class="header-logout__icon"
                    src="../assets/icons/logout.svg"
                    alt=""
                    srcset=""
                  />
                </div>
              </router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="header-logout__menu sp" outlined>
            <v-list-item-title outlined class="header-logout__menu--title">
              <router-link to="/support">
                <div @click="overlay = false">
                  Hỗ trợ
                  <img
                    class="header-logout__icon"
                    src="../assets/icons/support.svg"
                    alt=""
                    srcset=""
                  />
                </div>
              </router-link>
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="header-logout__menu fix" outlined>
            <v-list-item-title outlined class="header-logout__menu--title">
              <router-link to="">
                <div @click=";(overlay = false), clearCache()">
                  Sửa lỗi
                  <!-- <img
                    class="header-logout__icon"
                    src="../assets/icons/support.svg"
                    alt=""
                    srcset=""
                  /> -->
                  <v-icon class="header-logout__menu fix--icon"
                    >mdi-reload</v-icon
                  >
                </div>
              </router-link>
            </v-list-item-title>
          </v-list-item>
          <!-- mdi-reload-alert -->
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-overlay color="#fff" opacity="0.97" :value="overlay"> </v-overlay>
    <v-dialog
      v-if="
        !isAuthenticated &&
          this.$route.path !== '/login' &&
          this.$route.path !== '/' &&
          loginRequired === true
      "
      v-model="dialogLogin"
      persistent
      overlay-opacity="0.97"
      overlay-color="#fff"
      max-width="290"
    >
      <v-card class="dialog-login">
        <v-card-title class="dialog-login__title headline justify-center">
          Thông báo
        </v-card-title>
        <v-card-text class="text-center"
          >Vui lòng Đăng nhập để trải nghiệm các giftcode hấp dẫn dành riêng cho
          bạn.</v-card-text
        >
        <v-card-actions class="justify-center">
          <v-btn
            class="dialog-login__btn white--text text-none"
            color="#e88d50"
            outlined
            height="50px"
            @click="loggedIn"
          >
            Đăng nhập VGPID
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import $ from 'jquery'
import { mapGetters, mapState } from 'vuex'
import { Authenticate, Buttons } from '../services/functions'

export default {
  name: 'AppBar',
  data: () => ({
    dialogLogin: true,
    overlay: false,
    activeClass: false,
  }),
  computed: {
    ...mapGetters(['isAuthenticated']),
    ...mapState({
      username: state =>
        state.auth.username === '' ? state.user.username : state.auth.username,
      loginRequired: state => state.status.login_required,
    }),
  },
  methods: {
    logout: Authenticate.logout,
    goBack: Buttons.goBack,
    loggedIn: Authenticate.loggedIn,
    support: Buttons.support,
    clearCache: Buttons.clearCache,
  },
  mounted() {
    const $this = this
    $('body').click(function() {
      $this.overlay = false
    })
    $('.v-overlay').click(function() {
      $this.overlay = false
    })
  },
}
</script>

<style lang="scss" scoped>
.v-toolbar__content,
.v-toolbar__extension {
  padding: 0 !important;
}
.v-menu__content.theme--light,
.v-menu__content.theme--light.menuable__content__active {
  box-shadow: none;
  left: auto !important;
  right: 14px;
  width: 141px;
  padding: 0;
  top: 57px !important;
}
.dialog-login {
  border-radius: 15px !important;
  padding-bottom: 20px;
  &__btn {
    border-radius: 15px !important;
    border: none !important;
    background: linear-gradient(180deg, #df6f58 0%, #e88d50 100%);
  }
  &__title {
    color: #e88d50;
  }
}

.activeSupport {
  display: none;
}
</style>
